module.exports = __webpack_public_path__ + "img/addmail1.0d6edf19.svg";